import React, { FC, PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';

import { ThemeProvider } from '@mui/material/styles';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import LocalStorage from '@src/LocalStorage';
import theme from '@src/theme/theme';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AuthorizationContext from '@contexts/common/AuthorizationContext';
import ModalsProvider from '@contexts/common/ModalContext';

import { Wagmi } from '@tools/wagmi';

import Layout from '@components/common/Layout';

import Modals from '@modules/modals';

import {
  TOAST_DEFAULT_AUTO_CLOSE_TIME,
  TOAST_DEFAULT_POSITION,
} from '@constants/common/toast.constants';

const queryClient = new QueryClient();

const Providers: FC<PropsWithChildren> = ({ children }) => (
  <ModalsProvider>
    <LocalStorage>
      <Wagmi>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider theme={darkTheme()} locale="en-US">
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            <ThemeProvider theme={theme}>
              <AuthorizationContext>
                <Layout>{children}</Layout>
                <Modals />
                <ToastContainer
                  position={TOAST_DEFAULT_POSITION}
                  autoClose={TOAST_DEFAULT_AUTO_CLOSE_TIME}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  icon={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </AuthorizationContext>
            </ThemeProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </Wagmi>
    </LocalStorage>
  </ModalsProvider>
);

export default Providers;
